import axios from "@/utils/axios";
import { ABIBARO_ENABLED } from "@/config/Features";

export default class AbibaroService {
  public static checkAbibaroRegistration(): Promise<boolean> {
    if (!ABIBARO_ENABLED) return Promise.resolve(false);

    return axios
      .get("financial-config/school-registered-in-abibaro")
      .then((res: any) => {
        const { data } = res;
        return data;
      })
      .catch((er: any) => false);
  }
}
